import { TFilterSelected, TRESPONSE_TNA_BOARD_LISTING } from '@monorepo/types';
import { UTILS_GUARDS } from '../ui-filter.guards';
import { UiFilterModifiers } from '../ui-filter.modifier';
import { TFilterGroupModel, TOrgFilter } from '../ui-filter.types';

export const TNA_BOARD_FILTER_MODEL = {
  createModel: (
    items: TFilterSelected[],
    whichType: 'LL_BOARD' | 'TNA_BOARD' | 'HL_BOARD' | 'OPL_DAILY_VIEW' | 'PLANNING_BOARD',
    stripStatusMetadataMap?: TRESPONSE_TNA_BOARD_LISTING['stripStatusMetadataMap'],
    extraPayloadForSearch?: any,
    prevModel?: TFilterGroupModel<TFilterSelected>,
    orgHierarchySelectedTree?: TOrgFilter['dynamicOrgHierarchy'],
  ) => {
    const getSearchEndPoint = () => {
      switch (whichType) {
        case 'LL_BOARD':
          return 'LL_FILTERS_SEARCH_API';
        case 'TNA_BOARD':
          return 'GET_TNA_BOARD_FILTERS_SEARCH';
        case 'HL_BOARD':
          return 'HL_BOARD_FILTERS_SEARCH_API';
        case 'OPL_DAILY_VIEW':
          return 'HL_OTL_FILTERS_SEARCH_API';
        case 'PLANNING_BOARD':
          return 'PLANNING_BOARD_FILTERS_SEARCH_API';
      }
    };
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          searchWithApi: item.searchable
            ? {
                searchService: 'plani8',
                searchEndPoint: getSearchEndPoint(),
                payload: extraPayloadForSearch,
              }
            : undefined,
          items: item.values.map((supportedVal) => {
            const valueTypeCast = supportedVal as keyof TRESPONSE_TNA_BOARD_LISTING['stripStatusMetadataMap'];
            return {
              value: supportedVal,
              isSelected: false,
              displayText:
                stripStatusMetadataMap && stripStatusMetadataMap[valueTypeCast]
                  ? stripStatusMetadataMap[valueTypeCast].displayName
                  : '',
            };
          }),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          hierarchy: item,
          isDisabled: false,
          ...(orgHierarchySelectedTree && {
            dynamicOrgHierarchy: orgHierarchySelectedTree,
          }),
          filteredOrgTree: {
            ...item,
            values: [],
          },
        };
      }
      throw new Error('Type Not suppported');
    });
    const updatedFilterModel = prevModel
      ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel)
      : createNewFilterModel;
    return UiFilterModifiers.sortFilterItems(updatedFilterModel);
  },
};

export const LINE_LEVEL_STRIP_LIST_FILTER_CONTAINER_MODEL = {
  createModel: (
    items: TFilterSelected[],
    selectedItems: TFilterSelected[],
    prevModel?: TFilterGroupModel<TFilterSelected>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isSelectFilter(item)) {
        const currKeySelectedValues = selectedItems.find((itms) => itms.key === item.key)?.values as (
          | string
          | number
        )[];
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((supportedVal) => {
            return {
              value: supportedVal,
              isSelected: currKeySelectedValues?.find((slcItm) => slcItm === supportedVal) ? true : false,
            };
          }),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: true,
          })),
          selectedValues: [],
        };
      }
      throw new Error('Type Not suppported');
    });
    const updatedFilterModel = prevModel
      ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel)
      : createNewFilterModel;
    return UiFilterModifiers.sortFilterItems(updatedFilterModel);
  },
};
